<template>
<div class="card">
    <div class="contenedorContenidoTiendaBloquesInterior">				
					<!--<img :src="articulo.img_promo"/>-->

          <div class="card-imagen">
						  <router-link :to="{ name: 'article', params: { id: articulo.Id } }" v-if="articulo.Imagen != ''">
							  <img :src="articulo.Imagen" class="card-img-top" style="float: left; object-fit: cover;height: 100%;width: 100%;" />
						  </router-link>
          </div>
					<div class="card-title">
						<router-link :to="{ name: 'article', params: { id: articulo.Id } }">
							{{ articulo.Nombre }}
						</router-link>						
					</div>										
					<div class="card-body">
						<label style="font-size:20px; font-weight:900;margin-top: 0px;color:#303030"> {{ articulo.Precio  }} </label>
            <label v-if="articulo.cantidad_stock > 0 && articulo.ControlStock" class="Stock" style="font-size:9px;line-height:6px">{{ $t('articulo.stock') }} {{ articulo.CantidadStock }}</label>
						<label v-else-if="articulo.ControlStock" class="NoStock" style="font-size:9px;line-height:6px">{{ $t('articulo.no_stock') }}</label>
					</div>
					
				</div>
				
				<div class="card-footer" style="margin-left:10px; margin-bottom:10px">
					
						<a class="btn btn-success" href="#" v-if="articulo.Vendible" v-on:click.prevent="anyadirAlCarro(articulo)">
							<img style="margin-right: 5px; vertical-align: middle" :src="src_carro" />
							<label>{{ $t('acciones.anyadir_al_carro') }}</label>
						</a>											
					
						<!--<a v-if="enCarro"  class="btn btn-danger" href="#" v-on:click.prevent="removeCarro(articulo)">
							<img style="margin-right: 5px; vertical-align: middle" :src="src_carro" />
							<label>remove</label>
						</a>						
						<router-link class="btn btn-info" :to="{ name: 'article', params: { id: articulo.Id } }">
							<img style="margin-right: 5px; vertical-align: middle" :src="src_lupa" />
							<label>{{ $t('acciones.ver_detalle') }}</label>
						</router-link>-->
        
					</div>
				</div>
			</div>
            </div>
</template>
<script>
export default {
  props: {
    src_lupa: String,
    src_carro: String,
    articulo: Object,
  },
  computed: {
    enCarro() {
      return this.$store.getters.getCantidad(this.articulo) > 0;
    },
  },
  methods: {
    anyadirAlCarro(articulo) {
		const cantidadActual = this.$store.getters.getCantidad(this.articulo);
		if(!articulo.ControlStock || (cantidadActual + 1) <= articulo.CantidadStock) {
      		console.log("anyadirAlCarro");
      		this.$store.commit("addLinea", articulo);
		}
    },
    removeCarro(articulo) {
      console.log("removeCarro", articulo);
      this.$store.commit("removeLinea", articulo);
    },
  },
  created() {
    console.log("articulo", this.articulo, this.src_lupa, this.src_carro);
  },
};
</script>
